export { default } from './SupportBanner';
